<!--
    Component PreviewDetail - Essentially Exhibition Vue with a close button
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div class="content" v-if="cursor < 0">

			<div class="archive-name bar darkText largeText">
				<div class="gridLabel bg-archiv">Vorschau</div>

				<div class="gridTriple bg-archiv-light">
					{{ exhibition.getName() }}
				</div>
				<div class="link archive-close" @click="$parent.select()">x</div>
			</div>

			<div class="archiv-detail-grid">
				<div 
					class='exhibition-image zoomable link'
					v-for="work in exhibition.getWorksByDisplaySort()"
					:key="work.getID()"
				>
					<img 
						v-if="work.getWork().getImages().isImage()"
						:src="work.getWork().getImages().getImageURL(previewImageQuality)"
						:title="work.getToolTip()"
						@click="select(work.getIndexByLink())">
					<div v-else 
						v-html="work.getWork().getImages().getMultiMediaHTML(0, 'preview')" 
						:title="work.getToolTip()"
						@click="select(work.getIndexByLink())"></div>
				</div>
			</div>

			<div class="exhibition-desc" v-html=" descriptionWithNewLines "></div>
		</div>

		<work-detail :list="list" :index="cursor"></work-detail>
	</div>
</template>

<script>

	import Vue from "vue";
	import { model } from "./../model/Model.js";
	import { ListWithCursor } from "./../mixin/ListWithCursor.js";
	import WorkDetail from "./WorkDetail.vue";

	export default {

		mixins: [ ListWithCursor ],
		components: { WorkDetail },
		props: ["exhibition"],


		data: function() {
			return {
				// expose model for translations
				model: model,
				// source of the preview images
				previewImageQuality: 'small',
			};
		},

		computed: {
			// Prepare the Description for display by adding newlines
			descriptionWithNewLines: function() {
				return this.exhibition.getDescription().replace(/\n/g, "<br>");
			}
		},

		created: function() {
			let linkSorted = this.exhibition.getWorksByLinkSort();
			for (let i = 0; i < linkSorted.length; i++) {
				linkSorted [i].setIndexByLink(i);
				this.list.push(linkSorted [i]);
			}
			this.previewImageQuality = Vue.prototype.$previewImageQuality;
		}

	};
</script>


<style>

@media (min-width: 1000px) {

	div.archive-close {
		display: inline;
		position: absolute;
		right: 1rem;
		top: 0rem;
	}

	div.archive-name {
		margin-bottom: 0!important;
	}

	div.archive-name div.gridTriple{
		margin-right: 0 !important;
		width: 33rem !important;
	}

}

@media (max-width: 1000px) {

	div.archive-close {
		position: absolute;
		top: 2.5rem;
		right: 1rem;
		font-size: 2rem;
	}

	div.archive-name {
		margin-bottom: 0!important;
	}

	div.archive-name div.gridTriple{
		margin-right: 0 !important;
		width: 32.5rem !important;
	}

}

	div.archiv-detail-name {
		background-color: #93c4c6;
		color: black;
		font-size: 1.6rem;
		padding: 0.4rem 2rem 0.2rem 2rem;
		display: inline-block;
	}

	div.archiv-detail-grid {
		border: 0.2rem solid #dcad69;
		padding: 1rem;

		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	div.exhibition-image {
		height: 9rem;
		margin: 1rem;
	}

	div.exhibition-image img {
		height: 9rem;
	}

	div.exhibition-image div {
		height: 9rem;
		width: 16rem;
	}

	div.exhibition-desc {
		margin-top: 2rem;
	}
</style>